import { module } from 'angular'

export default module('contabilidad.shared', [
  'interface',
])



// WEBPACK FOOTER //
// ./src/contabilidad/shared/module.js